var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(9155 -11246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_34097",
    "data-name": "Rectangle 34097",
    transform: "translate(-9155 11246)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search-new",
    transform: "translate(-9153.619 11247.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search-new-2",
    "data-name": "search-new",
    d: "M4.124,11.557a7.433,7.433,0,1,1,7.433,7.433A7.433,7.433,0,0,1,4.124,11.557ZM11.557,2a9.557,9.557,0,1,0,5.967,17.024l3.9,3.9a1.062,1.062,0,1,0,1.5-1.5l-3.9-3.9A9.558,9.558,0,0,0,11.557,2Z",
    transform: "translate(-2.001 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.47ea46df53b9e90ae8c810cde002c4f6.svg";
export { ForwardRef as ReactComponent };